import { Link } from "react-router-dom";
import { ApplyCTA } from "./ApplyCTA";
import { useT, useLang } from "../../i18n";

export const Footer = () => {
  const year = new Date().getFullYear();
  const t = useT();
  const lang = useLang();
  const homeHref = lang === "en" ? "/" : "/es";
  return (
    <footer className="sp-footer" data-testid="site-footer">
      <div className="sp-container sp-footer-inner">
        <div className="sp-footer-top">
          <Link
            to={`${homeHref}#top`}
            className="sp-footer-brand"
            data-testid="footer-brand"
            aria-label="Stella Polaris"
          >
            <img src="/stella-polaris-star.png" alt="" />
            <span className="sp-nav-brand-text">
              <span className="name">{t.nav.brand}</span>
              <span className="tag">{t.footer.tagline}</span>
            </span>
          </Link>
          <div className="sp-footer-links">
            {t.nav.links.map((l) => (
              <a
                key={l.href}
                href={`${homeHref}${l.href}`}
                className="sp-underline"
              >
                {l.label}
              </a>
            ))}
            <Link
              to={lang === "en" ? "/about" : "/es/about"}
              className="sp-underline"
              data-testid="footer-link-about"
            >
              {t.nav.about}
            </Link>
            <Link
              to={lang === "en" ? "/insights" : "/es/insights"}
              className="sp-underline"
              data-testid="footer-link-insights"
            >
              {t.nav.insights}
            </Link>
            <Link
              to={lang === "en" ? "/contact" : "/es/contact"}
              className="sp-underline"
              data-testid="footer-link-contact"
            >
              {t.nav.contact}
            </Link>
            <ApplyCTA
              testId="footer-apply"
              variant="link"
              appliedLabel={t.footer.appliedLabel}
              withArrow={false}
            >
              {t.footer.apply}
            </ApplyCTA>
          </div>
        </div>
        <div className="sp-footer-bottom">
          <span>{t.footer.bottomLeft(year)}</span>
          <span>{t.footer.bottomRight}</span>
        </div>
      </div>
    </footer>
  );
};
